const PreviewsActions = ({
  countSelected,
  selectAllPreview,
  deSelectPreview,
  downloadImages,
  imageIsAdded,
  analytics,
  previewActiveCategory,
  previewsSelected
}) => {
  const styleVisibleSelectedPreviews = {
    display: countSelected ? "inline-block" : "none",
  };

  const styleHiddenSelectedPreviews = {
    display: !countSelected ? "inline-block" : "none",
  };

  return (
    <div className="previews__actions">
      <span>{countSelected > 0 ? `${countSelected} Image selected` : ""}</span>
      <div className="selector">
        <button style={styleHiddenSelectedPreviews} onClick={() => {
          analytics.sendSelectAllPreview(previewActiveCategory)
          selectAllPreview()
          }}>
          Select All
        </button>

        <button
          className="active"
          disabled={imageIsAdded}
          onClick={() => {
            analytics.sendDownloadSelectPreview(previewActiveCategory, previewsSelected.join(', '));
            downloadImages();
          }}
          style={styleVisibleSelectedPreviews}
        >
          Download Selected Images
        </button>
        <button style={ styleVisibleSelectedPreviews } onClick={ deSelectPreview }>
          Deselect All
        </button>
      </div>
    </div>
  );
};

export default PreviewsActions;
